<template>
  <div
    class="gw_box"
    style="--box-padding: 0"
  >
    <div
      class="gw_box gw_box_widget_title cursor-pointer"
      style="justify-content: space-between"
    >
      {{ $t('dashboard_links.selected_links') }}

      <slot name="title"></slot>
      <div
        class="icon_btn mdi mdi-pencil pa-2 csst csst_nm"
        @click="openDashboardSettingsDialog"
      >
        <div
          class="csst_content text-nowrap"
          style="left: -0.25em; transform: translate(-100%, 0)"
          v-html="$t('tooltips.dashboard_settings')"
        ></div>
      </div>
    </div>
    <div
      class="dashboard-links dashlinks gw_box"
      style="--box-padding: 1rem"
    >
      <div
        v-if="dashboardLinks.length"
        class="dashlinks_links"
      >
        <div
          v-for="(item, iIdx) in dashboardLinks"
          :key="`${item.name}_${iIdx}`"
          class="dashlinks_links_item"
        >
          <component
            :is="item.href ? 'a' : 'router-link'"
            :data-tst="item.id"
            v-bind="
              item.href
                ? {
                    href: item.href,
                    target: '_blank',
                  }
                : {
                    to: { name: item.pathName, query: item.query || {} },
                  }
            "
            class="flex-1"
          >
            <NavCard
              :item="item"
              class="navcard_dashboard flex-1"
              :style="`
          --height:100%;
          ${item.tag_live ? tagLiveStyle : ''};
           --clr-icon-back:${item.clr_main};
           --clr-title-hover:${item.clr_main};
           --clr-icon:var(--clr-black-1);
           --clr-icon-hover:var(--clr-black-1);
           --clr-sub:var(--clr-grey-2);
           --icon-radius: 8px;
           --icon-size: 2.875rem;
           --icon-font-size: 2.125rem;
              ${item.style || ''}
           `"
              :hasTag="item.pathName === 'PracticeTrainer' ? !!item.tag_live : false"
              @click="e => handleClick({ e, item })"
            >
              <template
                v-if="item.id === 'StudySolutions'"
                #title
              >
                <div class="d-flex">
                  <div class="position-relative mr-auto">
                    {{ item.title }}
                  </div>
                </div>
              </template>
            </NavCard>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'

export default {
  name: 'DashboardLinks',
  mixins: [links_mix],
  data() {
    this.tagLiveStyle = `
        --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
        `
    return {
      editing: false,
    }
  },
  methods: {
    handleClick({ e, item }) {
      if (item.fn) {
        item.fn({ e, item })
      }
    },
    openDashboardSettingsDialog() {
      this.$store.dispatch('router_set_dialogs', 'dashboard-settings-dialog')
    },
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
  },
  computed: {
    dashboardLinks() {
      const links = this.$store.getters.dashboardLinks
      const res = []
      links.forEach(key => {
        // --icon-transform
        if (this.links_all[key]) {
          if (this.links_all[key].g1_hide && this.$i18n.g1) {
            return
          }
          res.push(this.links_all[key])
        }
      })
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>
<style lang="scss">
.dashlinks {
  &_icon {
    &_helpcenter {
      &:before {
        transform: scale(0.75);
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.dashlinks {
  --clr-back: var(--clr-black-0);
  position: relative;
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  &_links {
    --display: grid;
    --gap: 1rem;
    --grid-template-columns: repeat(3, 1fr);
    display: var(--display);
    grid-template-columns: var(--grid-template-columns);
    grid-gap: var(--gap);
    position: relative;

    z-index: 1;
    flex: 1;
    &_item {
      position: relative;
      display: flex;
    }
  }
}

@media (max-width: 822px) {
  .dashlinks {
    &_links {
      --grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 520px) {
  .dashlinks {
    &_links {
      --grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>
